<script lang="ts" setup>
import SkrButton from '@/components/button/SkrButton.vue'

const { t } = useI18n()

const refresh = () => {
  window.location.reload()
}
</script>

<template>
  <v-app-bar color="info" app flat>
    <div class="d-flex justify-center flex-grow-1">
      <div class="d-flex align-center gap-2">
        <v-icon size="20">custom:info</v-icon>
        <span>{{ t('banner.version_update.text') }}</span>
        <skr-button size="sm" type="secondary" color="white" @click="refresh">
          {{ t('global.refresh') }}
        </skr-button>
      </div>
    </div>
  </v-app-bar>
</template>
